module.exports = __webpack_public_path__ + "proximanova-regular-webfont.7526cc98fd7c64bd3c9c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/proximanova-regular-webfont.woff2
// module id = 254
// module chunks = 2